import { createFileRoute } from "@tanstack/react-router";
import { IssuesBoard } from "#app/components/issues/issues-board";
import { useWorkflowId } from "#app/lib/hooks/use-workflow-id";

/** `/workflow/$workflowId/board` — the workflow Kanban, scoped to one workflow. */
function WorkflowBoardRoute() {
  const workflowId = useWorkflowId();
  if (!workflowId) return null;
  return <IssuesBoard scope={{ kind: "workflow", workflowId }} />;
}

export const Route = createFileRoute(
  "/(app)/$workspace/workflow/$workflowId/board",
)({
  component: WorkflowBoardRoute,
});
